import { FC } from 'react';
import { SurveyStatisticPage } from './survey-statistic.page';

export const SurveyStatisticsAdminLevelPage: FC = () => <SurveyStatisticPage isAdminRoute={true} />;
